import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'pu-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],
})
export class FooterComponent {}
